import {
  Activity,
  AlertCircle,
  Anchor,
  Aperture,
  Archive,
  AtSign,
  BadgeCheck,
  BarChart3,
  Bell,
  Bike,
  BookOpen,
  Bookmark,
  Briefcase,
  Brush,
  Calculator,
  Calendar,
  Camera,
  Car,
  CheckCircle2,
  Circle,
  Clipboard,
  Cloud,
  Code2,
  Compass,
  Cpu,
  Database,
  FileText,
  Flag,
  Folder,
  Gamepad2,
  Gauge,
  Gift,
  Globe2,
  GraduationCap,
  Hammer,
  Heart,
  Home,
  KeyRound,
  Lightbulb,
  Link,
  Lock,
  Mail,
  Map,
  Megaphone,
  MessageCircle,
  Mic,
  Monitor,
  Music,
  Package,
  Palette,
  Pencil,
  Phone,
  PieChart,
  Plane,
  Rocket,
  Search,
  Send,
  Settings,
  Shield,
  ShoppingBag,
  Sparkles,
  Star,
  Sun,
  Tag,
  Terminal,
  ThumbsUp,
  Timer,
  Trophy,
  Truck,
  UserRound,
  Wand2,
  Wrench,
  Zap,
  Bot,
  type LucideIcon,
} from "lucide-react";

// The icon registry is intentionally exported for the agent picker.
export const agentIcons: Record<string, LucideIcon> = {
  Activity,
  AlertCircle,
  Anchor,
  Aperture,
  Archive,
  AtSign,
  BadgeCheck,
  BarChart3,
  Bell,
  Bike,
  BookOpen,
  Bookmark,
  Briefcase,
  Brush,
  Calculator,
  Calendar,
  Camera,
  Car,
  CheckCircle2,
  Circle,
  Clipboard,
  Cloud,
  Code2,
  Compass,
  Cpu,
  Database,
  FileText,
  Flag,
  Folder,
  Gamepad2,
  Gauge,
  Gift,
  Globe2,
  GraduationCap,
  Hammer,
  Heart,
  Home,
  KeyRound,
  Lightbulb,
  Link,
  Lock,
  Mail,
  Map,
  Megaphone,
  MessageCircle,
  Mic,
  Monitor,
  Music,
  Package,
  Palette,
  Pencil,
  Phone,
  PieChart,
  Plane,
  Rocket,
  Search,
  Send,
  Settings,
  Shield,
  ShoppingBag,
  Sparkles,
  Star,
  Sun,
  Tag,
  Terminal,
  ThumbsUp,
  Timer,
  Trophy,
  Truck,
  UserRound,
  Wand2,
  Wrench,
  Zap,
};

export const defaultAgentIcon = "Bot";
agentIcons.Bot = Bot;
export function AgentIcon({
  name,
  size = 16,
  className,
}: {
  name?: string | null;
  size?: number;
  className?: string;
}) {
  const Icon = (name && agentIcons[name]) || Bot;
  return <Icon size={size} className={className} aria-hidden="true" />;
}
